import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CaseList').create(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
    // display: 'grid',
    // width: '100%',
    // height: '100%',
    // gridTemplateColumns: '1fr 1fr',
    // gridAutoRows: '1fr',
    // gap: '8px',
  },
}))
